import axios from 'axios'
import config from './config'
import _ from 'lodash'

class Api {
    static _toko = null
    static daftar_toko = []

    static getThumb2Url(fotoId) {
        return this._toko.api_url + 'thumb2/' + fotoId
    }

    static getFotoUrl(fotoId) {
        return this._toko.api_url + 'foto/' + fotoId
    }

    static getThumb1Url(fotoId) {
        return this._toko.api_url + 'thumb1/' + fotoId
    }

    static setToko(toko) {
        let base_url = toko.api_url
        this.baseUrlFoto = base_url + 'foto/'
        this.baseUrlThumb1 = base_url + 'thumb1/'
        this.baseUrlThumb2 = base_url + 'thumb2/'
        this._toko = toko
        // console.dir(this)
    }

    static getNamaToko() {
        return this.getToko()?.nama
    }

    static getDaftarToko() {
        return this.daftar_toko
        // return config.daftar_toko
    }

    static getTokoById(id) {
        let daftar = config.daftar_toko
        return _.find(daftar, { id })
    }

    static getToko() {
        return this._toko
        // return this.getTokoById(config.toko_id)
    }

    static getTokoId() {
        return this.getToko()?.id
    }


    static getShowHargaGrosir() {
        return this.getToko()?.show_harga_grosir
    }

    static getGudangId() {
        return parseInt(localStorage.getItem("gudangId") || -1)
    }

    static setGudangId(gudangId) {
        localStorage.setItem("gudangId", gudangId + "")
    }

    static getBaseUrl() {
        return this.getToko()?.api_url
    }

    static getLogo() {
        return `/img/logo/${Api.getToko()?.id?.toLowerCase()}.png`
    }

    static getSideImage() {
        return '/img/sidebar/sidebar.jpg'
    }

    static async login(user, password) {
        let api
        try {
            let res = await axios.post(Api.getBaseUrl() + 'login2', {
                user,
                password
            })
            api = res.data
        } catch (er) {
            console.error(er)
        }
        return api
    }

    static isLoggedIn() {
        let token = localStorage.getItem("token") || ""
        return token.length > 0
    }

    static logout() {
        localStorage.setItem("token", "")
    }

    static setToken(token, user) {
        localStorage.setItem("token", token)
        localStorage.setItem("user", user)
    }

    static getUser() {
        return localStorage.getItem("user") || ""
    }

    static isNeedLogin() {
        return Api.getShowHargaGrosir()
    }

    static async getHomeData(gudangId) {
        let api
        try {
            let res = await axios.post(Api.getBaseUrl() + 'home2', {
                gudangid: gudangId
            })
            api = res.data
        } catch (er) {
            console.error(er)
        }
        return api
    }

    static getBarangBySku(sku) {
        return new Promise((resolve, reject) => {
            axios.post(Api.getBaseUrl() + 'barang', { sku })
                .then(res => {
                    let api = res.data
                    if(!api.ok) {
                        reject(res.msg)
                    }
                    if(!api.data) {
                        reject('Data tidak ditemukan')
                    }
                    resolve(api.data)
                })
                .catch(er => reject(er))
        })
    }

    static async getDaftarBarang(cari, kategoriId, brandId, skip, take, sort = 'created desc', gudangId = -1) {
        let api = {
            ok: false,
            msg: ''
        }
        let res = await axios.post(Api.getBaseUrl() + 'caribarang', { cari, kategoriId, brandId, skip, take, sort, gudangid: gudangId })
        api = res.data
        return api
    }

    static async getDaftarKategori() {
        let api = {
            ok: false,
            msg: ''
        }
        let res = await axios.post(Api.getBaseUrl() + 'kategori')
        api = res.data
        return api
    }

    static async getDaftarFooter(gudang_id) {
        let api = {
            ok: false,
            msg: ''
        }
        let res = await axios.post(Api.getBaseUrl() + 'footers', { gudang_id })
        api = res.data
        return api
    }

    static async getBarang(id) {
        let api = {
            ok: false,
            msg: ''
        }
        let res = await axios.post(Api.getBaseUrl() + 'detailbarang/' + id)
        api = res.data
        return api
    }

    static async getDaftarGudang(toko_id) {
        let ret = []
        let res = await axios.post(Api.getBaseUrl() + 'daftargudang', { toko_id })
        ret = res.data
        return ret
    }
}

export default Api